module.exports = __webpack_public_path__ + "static/img/4.21b6dba1.jpg";